const $ = require("jquery");
require("slick-carousel");

$(function () {
    // ---- Reviews carousel (prev/next arrows, 3 up) ----
    // Same config as event-booking/main.js - this is a shared, reusable block.
    const $slider = $(".mc__reviews-slider");
    if ($slider.length) {
        const $nav = $(".mc__reviews-nav");
        const prevLabel = $nav.data("prev-label") || "Previous";
        const nextLabel = $nav.data("next-label") || "Next";
        const arrowSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M12 5l7 7-7 7"/></svg>';

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true,
            speed: 300,
            dots: false,
            arrows: true,
            appendArrows: $nav.length ? $nav : $slider,
            prevArrow: '<button type="button" class="mc__reviews-arrow mc__reviews-arrow--prev" aria-label="' + prevLabel + '">' + arrowSvg + '</button>',
            nextArrow: '<button type="button" class="mc__reviews-arrow mc__reviews-arrow--next" aria-label="' + nextLabel + '">' + arrowSvg + '</button>',
            responsive: [
                { breakpoint: 1200, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 1 } }
            ]
        });
    }

});
